export default __webpack_public_path__ + "static/allLogosMobile-3aace985f66e40716e0ab0c15bb0f058.png";